<template>
  <div class="mobile-header">
    <button class="mobile-menu-button" @click="$emit('toggle-sidebar')" aria-label="Toggle Menu">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="3" y1="12" x2="21" y2="12"></line>
        <line x1="3" y1="6" x2="21" y2="6"></line>
        <line x1="3" y1="18" x2="21" y2="18"></line>
      </svg>
    </button>
    <h1 class="mobile-title" style="font-size: 1.5rem; font-weight: 600; color: var(--gray-900); margin: 0; padding-left: 5rem;">{{ title }}</h1>
  </div>
</template>

<script>
export default {
  name: 'MobileHeader',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  emits: ['toggle-sidebar']
};
</script> 